import { useParams } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import { toast } from "../../helper/common";
import { Button, Modal, Select, Switch } from "../design";
import "./shareWorkspace.css";

const ConfirmRemovalModal = ({
  onClose,
  confirmPopupType,
  selectedFields,
  dataType,
  onCloseMain,
  refreshFunc,
}) => {
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const { user } = useContext(AuthContext);
  const { addToWorkspace, removeFromWorkspace, getShareProfilesForProperty } =
    useContext(LandLordContext);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [apiCallLoading, setApiCallLoading] = useState(false);
  const [includeAssociatedTenants, setIncludeAssociatedTenants] =
    useState(true);

  const handleChangeWorkspace = (e) => {
    setSelectedWorkspace(e.target.value);
  };

  const getAssociatedTenantShareProfileIds = async (propertyIds) => {
    const results = await Promise.all(
      propertyIds.map((propertyId) => getShareProfilesForProperty(propertyId))
    );
    return results
      .flatMap((data) =>
        (data?.sharedProfiles ?? []).map((profile) => profile?._id)
      )
      .filter(Boolean);
  };

  const handleSubmitButton = async () => {
    if (
      selectedFields?.length === 0 ||
      (confirmPopupType == "add" && !haveValue(selectedWorkspace))
    ) {
      toast.error(_t("workspaceEntryCouldNotBeEmpty"));
      return;
    }
    if (confirmPopupType == "add") {
      setApiCallLoading(true);
      const applications = selectedFields.filter((item) => item?.isApplication);
      const nonApplications = selectedFields.filter(
        (item) => !item?.isApplication
      );

      const promises = [];

      if (applications.length > 0) {
        promises.push(
          addToWorkspace({
            workspaceId: selectedWorkspace,
            dataType,
            applicationIds: applications.map((item) => item?.applicationId),
          })
        );
      }

      if (nonApplications.length > 0) {
        const sharedProfileIds =
          dataType == "properties" && includeAssociatedTenants
            ? await getAssociatedTenantShareProfileIds(
                nonApplications.map((item) => item.value)
              )
            : [];

        promises.push(
          addToWorkspace({
            workspaceId: selectedWorkspace,
            dataType,
            ids: nonApplications.map((item) => item.value),
            ...(dataType == "properties" && { includeAssociatedTenants }),
            ...(dataType == "properties" &&
              includeAssociatedTenants && { sharedProfileIds }),
          })
        );
      }

      Promise.all(promises)
        .then((res) => {
          toast.success(_t("entriesAddedInWorkspace"));
          onCloseMain();
        })
        .catch((err) => {
          toast.error(_t("errorWhileAddingInWorkspace"));
        })
        .finally(() => {
          setApiCallLoading(false);
        });
    } else {
      setApiCallLoading(true);
      const applications = selectedFields.filter((item) => item?.isApplication);
      const nonApplications = selectedFields.filter(
        (item) => !item?.isApplication
      );

      const promises = [];

      if (applications.length > 0) {
        promises.push(
          removeFromWorkspace({
            dataType,
            applicationIds: applications.map((item) => item.applicationId),
          })
        );
      }

      if (nonApplications.length > 0) {
        promises.push(
          removeFromWorkspace({
            dataType,
            ids: nonApplications.map((item) => item.value),
          })
        );
      }

      Promise.all(promises)
        .then((res) => {
          toast.success(_t("entriesRemovedFromWorksapce"));
          refreshFunc();
          onCloseMain();
        })
        .catch((err) => {
          toast.error(_t("errorWhileRemovingFromWorksapce"));
        })
        .finally(() => {
          setApiCallLoading(false);
        });
    }
  };

  console.log(selectedFields, "selectedFieldsselectedFields ");

  const isAdd = confirmPopupType == "add";

  return (
    <Modal
      open
      onClose={onClose}
      size="md"
      align="start"
      title={
        <>
          {isAdd
            ? _t("confirmSharingFromWorkspace")
            : _t("confirmRemovalFromWorkspace")}{" "}
          {user?.workspaceIds?.find(
            (val) => val?.uuid?.toString() === workspaceId?.toString()
          )?.name ?? ""}
        </>
      }
      description={
        isAdd
          ? dataType == "properties"
            ? _t("areYouSureYouWantToAddThisPropertyFromYourWorkspace")
            : _t("areYouSureYouWantToAddThisUserFromYourWorkspace")
          : dataType == "properties"
            ? _t("areYouSureYouWantToRemoveThisPropertyFromYourWorkspace")
            : _t("areYouSureYouWantToRemoveThisUserFromYourWorkspace")
      }
      actions={
        <>
          <Button variant="secondary" size="lg" onClick={onClose}>
            {_t("noGoBack")}
          </Button>
          <Button
            variant={isAdd ? "primary" : "danger"}
            size="lg"
            loading={apiCallLoading}
            disabled={isAdd && !haveValue(selectedWorkspace)}
            onClick={handleSubmitButton}
          >
            {isAdd ? _t("yesAdd") : _t("yesRemove")}
          </Button>
        </>
      }
    >
      <div className="share-ws__confirm-body">
        {isAdd && (
          <Select
            id="share-workspace-target"
            name="gurantor_relation"
            label={_t("workspace")}
            placeholder={_t("pleaseSelect")}
            value={selectedWorkspace ?? ""}
            onChange={handleChangeWorkspace}
            options={(user?.workspaceIds ?? []).map((val) => ({
              value: val?._id,
              label: val?.name,
            }))}
          />
        )}
        {isAdd && dataType == "properties" && (
          <Switch
            id="share-workspace-include-tenants"
            label={_t("includeAssociatedTenants")}
            description={_t("awardedTenantsAndGuarantorsMoveWithTheProperty")}
            checked={includeAssociatedTenants}
            onChange={() =>
              setIncludeAssociatedTenants((prevValue) => !prevValue)
            }
          />
        )}
        <p className="share-ws__confirm-count">
          {selectedFields?.length}{" "}
          {dataType == "properties"
            ? _t("propertiesSelected")
            : _t("tenantsSelected")}
        </p>
      </div>
    </Modal>
  );
};

export default ConfirmRemovalModal;
